import { EvStation, LocalParking } from "@mui/icons-material";
import { ReactComponent as AvatarIcon } from "../../../features/Booking-Form/assets/avatar.svg";
import { ReactComponent as ConferenceIcon } from "../../../features/Booking-Form/assets/conference.svg";
import { ReactComponent as TeamIcon } from "../../../features/Booking-Form/assets/group.svg";
import {
  BookingType,
  NotSerializedBookingInputs
} from "../../../features/Booking-Form/typings/booking-inputs";

type P = {
  inputs: NotSerializedBookingInputs;
};

export function LocationAvailableIconPerBookingType({ inputs }: Readonly<P>) {
  switch (inputs.mode) {
    case BookingType.WORKPLACE:
      return <AvatarIcon width={"28px"} height={"28px"} />;
    case BookingType.TEAM:
      return <TeamIcon width={"28px"} height={"28px"} />;
    case BookingType.CONFERENCEZONE:
      return <ConferenceIcon width={"28px"} height={"28px"} />;
    case BookingType.PARKINGPLACE:
      return <LocalParking width={"28px"} height={"28px"} />;
    case BookingType.ELECTRICCHARGINGSTATIONPLACE:
      return <EvStation width={"28px"} height={"28px"} />;
    default:
      return <AvatarIcon width={"28px"} height={"28px"} />;
  }
}
